export var ChorePriority;
(function (ChorePriority) {
    ChorePriority["MUST_DO"] = "MUST_DO";
    ChorePriority["SHOULD_DO"] = "SHOULD_DO";
    ChorePriority["CAN_DO"] = "CAN_DO";
})(ChorePriority || (ChorePriority = {}));
